import { Button, Col, DatePicker, Form, Row, Select, Space } from 'antd';
import { Badge } from 'flowbite-react';
import React from 'react';
import { useLoaderData, useOutletContext } from 'react-router-dom';
import useSettingsAPI from '../apis/settingAPI';


// const dummy = [
//   {value: '238032', label: 'Road Expense'},
//   {value: 'hiww', label: 'Road Income'}
// ]


const Settings = () => {
  const {taxes, journals, accounts, settings} = useLoaderData();
  const [form] = Form.useForm();
  const { save, update } = useSettingsAPI();
  
  const handleSave = () => {
    let info = form.getFieldsValue();
    let keys = Object.keys(info);
    let data = [];
    keys.forEach((key, idx) => {
      let obj = {name: key, data: info[key]};
      data.push(obj);
    });
    console.log(info);
    update(data);
  }

  const filter = (input, option) => (
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
  )

  return (
    <div className='container mx-auto' style={{maxWidth: '1200px'}}>
      <Button onClick={handleSave}>Save</Button>
      <Form form={form} initialValues={settings} variant='borderless' labelCol={{span: 8}} labelWrap={true} labelAlign='left' className='bg-white '>
        <Row>
          <Badge className="text-black-900 font-bold bg-gray-100 rounded-none text-md w-full">Taxes</Badge>
          <Col md={{span: 12}} className='p-3'>
            <Form.Item label='Sales Tax' name={['taxes', 'sales_tax']} className='mb-1 font-semibold'>
              <Select name={'sales_tax'} options={taxes.map(tax => ({value: tax._id, label: tax.name}))} />
            </Form.Item> 
            <Form.Item label='Purchase Tax' name={['taxes', 'purchase_tax']} className='mb-1 font-semibold'>
              <Select name={'purchase_tax'} options={taxes.map(tax => ({value: tax._id, label: tax.name}))}/>
            </Form.Item> 
          </Col>
        </Row>
        <Row className='mt-5'>
          <Badge className="text-black-900 font-bold bg-gray-100 rounded-none text-md w-full">Vendor Bills</Badge>
          <Col md={{span: 12}} className='p-3'>
            <Form.Item name={['vendor bill', 'vendor_journal_id']} label='Default Journal' className='mb-1 font-semibold'>
              <Select options={[]} name='vendor_journal_id'/>
            </Form.Item>
          </Col>
        </Row>

        <Row className='mt-5'>
          <Badge className="text-black-900 font-bold bg-gray-100 rounded-none text-md w-full">Expense</Badge>
          <Col md={{span: 12}} className='p-3'>
            <Form.Item name={['expense', 'expense_journal_id']} label='Default Journal' className='mb-1 font-semibold'>
              <Select showSearch filterOption={filter} options={journals.map(journal => ({value: journal._id, label: journal.name}))} name='expense_journal_id'/>
            </Form.Item>
          </Col>
        </Row>

        <Row className='mt-5'>
          <Badge className="text-black-900 font-bold bg-gray-100 rounded-none text-md w-full">Customer Invoices</Badge>
          {/* <Space.Compact direction='vertical' className='w-full'> */}
            <Col md={{span: 12}} className='p-3'>
              <Badge className="text-gray-600 text-center p-0 font-bold bg-transparent rounded-none text-md w-full">Default Journal</Badge>
              <Form.Item name={['customer invoice', 'bank_payment_journal_id']} label='Bank Payment Journal' className='mb-1 font-semibold'>
                <Select showSearch filterOption={filter} options={journals.map(journal => ({value: journal._id, label: journal.name}))} name='bank_journal_id'/>
              </Form.Item>
              <Form.Item name={['customer invoice', 'cash_payment_journal_id']} label='Cash Payment Journal' className='mb-1 font-semibold'>
                <Select showSearch filterOption={filter} options={journals.map(journal => ({value: journal._id, label: journal.name}))} name='bank_journal_id'/>
              </Form.Item>
              <Form.Item name={['customer invoice', 'momo_payment_journal_id']} label='Momo Payment Journal' className='mb-1 font-semibold'>
                <Select showSearch filterOption={filter} options={journals.map(journal => ({value: journal._id, label: journal.name}))} name='bank_journal_id'/>
              </Form.Item>
            </Col>

            <Col md={{span: 12}} className='p-3'>
              <Badge className="text-gray-600 text-center p-0 font-bold bg-transparent rounded-none text-md w-full">Default Journals For Payment Methods</Badge>
              <Form.Item name={['customer invoice', 'bank_payment_journal_id']} label='Bank Payment Journal' className='mb-1 font-semibold'>
                <Select showSearch filterOption={filter} options={journals.map(journal => ({value: journal._id, label: journal.name}))} name='bank_journal_id'/>
              </Form.Item>
              <Form.Item name={['customer invoice', 'cash_payment_journal_id']} label='Cash Payment Journal' className='mb-1 font-semibold'>
                <Select showSearch filterOption={filter} options={journals.map(journal => ({value: journal._id, label: journal.name}))} name='bank_journal_id'/>
              </Form.Item>
              <Form.Item name={['customer invoice', 'momo_payment_journal_id']} label='Momo Payment Journal' className='mb-1 font-semibold'>
                <Select showSearch filterOption={filter} options={journals.map(journal => ({value: journal._id, label: journal.name}))} name='bank_journal_id'/>
              </Form.Item>
            </Col>
          {/* </Space.Compact> */}
        </Row>

        <Row className='mt-5'>
          <Badge className="text-black-900 font-bold bg-gray-100 rounded-none text-md w-full">Default Acccounts</Badge>
          <Col md={{span: 12}} className='p-3'>
            <Space.Compact direction='vertical' className='w-full'>
              {/* <Col md={{span: 24}} className='p-3'> */}
                <Badge className="text-gray-600 p-0 font-bold bg-transparent rounded-none text-md w-full">Post bank transactions and payments in</Badge>
                <Form.Item name={['default accounts', 'suspense_account_id']} label='Bank Suspense' className='mb-1 font-semibold'>
                  <Select showSearch filterOption={filter} options={accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`}))} name='income_account_id'/>
                </Form.Item>
                <Form.Item name={['default accounts', 'outstanding_receipt_id']} label='Outstanding Receipts' className='mb-1 font-semibold'>
                  <Select showSearch filterOption={filter} options={accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`}))} name='expense_account_id'/>
                </Form.Item>
                <Form.Item name={['default accounts', 'outstanding_payment_id']} label='Outstanding Payments' className='mb-1 font-semibold'>
                  <Select showSearch filterOption={filter} options={accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`}))} name='expense_account_id'/>
                </Form.Item>
                <Form.Item name={['default accounts', 'internal_transfer_account_id']} label='Internal Transfer' className='mb-1 font-semibold'>
                  <Select showSearch filterOption={filter} options={accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`}))} name='expense_account_id'/>
                </Form.Item>
            </Space.Compact>
          </Col>
          
          
        </Row>

        <Row className='mt-5'>
          <Badge className="text-black-900 font-bold bg-gray-100 rounded-none text-md w-full">Stock Valuation</Badge>
          <Col md={{span: 12}} className='p-3'>
            <Space.Compact direction='vertical' className='w-full'>
              {/* <Col md={{span: 24}} className='p-3'> */}
                <Badge className="text-gray-600 p-0 font-bold bg-transparent rounded-none text-md w-full">General Account Properties</Badge>
                <Form.Item name={['stock valuation', 'income_account_id']} label='Income Account' className='mb-1 font-semibold'>
                  <Select showSearch filterOption={filter} options={accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`}))} name='income_account_id'/>
                </Form.Item>
                <Form.Item name={['stock valuation', 'expense_account_id']} label='Expense Account' className='mb-1 font-semibold'>
                  <Select showSearch filterOption={filter} options={accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`}))} name='expense_account_id'/>
                </Form.Item>
            </Space.Compact>
          </Col>
          
          <Col md={{span: 12}} className='p-3'>
            <Badge className="text-gray-600 p-0 font-bold bg-transparent rounded-none text-md w-full">Automatic Accounting</Badge>
            <p className='text-gray-500'>The below account will be used by default for automatic inventory valuation</p>
            <Form.Item label='Stock Valuation Account' name={['stock valuation', 'stock_valuation_account_id']} className='mb-1 font-semibold focus:text-red-900 input-outline-none'>
              <Select showSearch filterOption={filter} options={accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`}))} name='stock valuation_account_id' />
            </Form.Item>
            <Form.Item label='Stock Journal' name={['stock valuation', 'stock_journal_id']} className='mb-1 font-semibold'>
              <Select showSearch filterOption={filter} options={journals.map(journal => ({value: journal._id, label: journal.name}))} name='stock_journal_id'/>
            </Form.Item>
            <Form.Item label='Stock Input Account' name={['stock valuation', 'stock_input_account_id']} className='mb-1 font-semibold'>
              <Select showSearch filterOption={filter} options={accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`}))} name='stock_input_account_id'/>
            </Form.Item>
            <Form.Item label='Stock Output Account' name={['stock valuation', 'stock_output_account_id']} className='mb-1 font-semibold'>
              <Select showSearch filterOption={filter} options={accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`}))} name='stock_output_account_id'/>
            </Form.Item>
          </Col>
        </Row>
        <Row className='mt-5'>
          <Badge className="text-black-900 font-bold bg-gray-100 rounded-none text-md w-full">Stock Valuation Reserved</Badge>
          <Col md={{span: 12}} className='p-3'>
            <Badge className="text-gray-600 text-center p-0 font-bold bg-transparent rounded-none text-md w-full">Automatic Accounting</Badge>
            <p className='text-gray-500'>The below account will be used by default for automatic reserved inventory valuation</p>
            <Form.Item label='Stock Reserved Valuation Account' name={['stock reserved valuation', 'stock_reserved_valuation_account_id']} className='mb-1 font-semibold focus:text-red-900 input-outline-none'>
              <Select showSearch filterOption={filter} options={accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`}))} name='stock valuation_account_id' />
            </Form.Item>
            <Form.Item label='Stock Reserved Journal' name={['stock reserved valuation', 'stock_reserved_journal_id']} className='mb-1 font-semibold'>
              <Select showSearch filterOption={filter} options={journals.map(journal => ({value: journal._id, label: journal.name}))} name='stock_journal_id'/>
            </Form.Item>
            <Form.Item label='Stock Reserved Account' name={['stock reserved valuation', 'stock_reserved_account_id']} className='mb-1 font-semibold'>
              <Select showSearch filterOption={filter} options={accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`}))} name='stock_input_account_id'/>
            </Form.Item>
          </Col>

          <Col md={{span: 12}} className='p-3'>
            <Badge className="text-gray-600 text-center p-0 font-bold bg-transparent rounded-none text-md w-full">Automatic Accounting</Badge>
            <p className='text-gray-500'>The below account will be used by default for automatic demand inventory valuation</p>
            <Form.Item label='Stock Demand Valuation Account' name={['stock demand valuation', 'stock_demand_valuation_account_id']} className='mb-1 font-semibold focus:text-red-900 input-outline-none'>
              <Select showSearch filterOption={filter} options={accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`}))} name='stock valuation_account_id' />
            </Form.Item>
            <Form.Item label='Stock Demand Journal' name={['stock demand valuation', 'stock_demand_journal_id']} className='mb-1 font-semibold'>
              <Select showSearch filterOption={filter} options={journals.map(journal => ({value: journal._id, label: journal.name}))} name='stock_journal_id'/>
            </Form.Item>
            <Form.Item label='Stock Demand Account' name={['stock demand valuation', 'stock_demand_account_id']} className='mb-1 font-semibold'>
              <Select showSearch filterOption={filter} options={accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`}))} name='stock_input_account_id'/>
            </Form.Item>
          </Col>
        </Row>
        <Row className='mt-5'>
          <Badge className="text-black-900 font-bold bg-gray-100 rounded-none text-md w-full">Accounting Entries</Badge>
          <Col md={{span: 12}} className='p-3'>
            <Form.Item name={['default entries account', 'account_receivable_id']} label='Default Receivable Account' className='mb-1 font-semibold'>
              <Select showSearch filterOption={filter} options={accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`}))} name='account_receivable_id'/>
            </Form.Item>
            <Form.Item name={['default entries account', 'account_payable_id']} label='Default Payable Account' className='mb-1 font-semibold'>
              <Select showSearch filterOption={filter} options={accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`}))} name='account_payable_id'/>
            </Form.Item>
            <Form.Item name={['default entries account', 'account_cost_of_revenue_id']} label='Default Cost of Revenue Account' className='mb-1 font-semibold'>
              <Select showSearch filterOption={filter} options={accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`}))} name='account_payable_id'/>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  )
}

export default Settings;